<template>
  <div>
    <v-dialog
      v-model="showModal"
      ref="ModalQRUser"
      hide-header
      hide-footer
      centered
      @hidden="hide"
      scroll-strategy="none"
    >
      <div class="h-100 overflow-y-auto">
        <div class="f-bold text-center">รหัสรับสินค้า</div>
        <v-tabs v-model="tabIndex" grow class="ignore-bg">
          <v-tab value="2"
            ><font-awesome-icon icon="qrcode" class="mr-2"></font-awesome-icon>
            Qr Code
          </v-tab>
          <v-tab value="1"
            ><font-awesome-icon icon="barcode" class="mr-2"></font-awesome-icon>
            Barcode
          </v-tab>
        </v-tabs>

        <v-window v-model="tabIndex">
          <v-window-item class="p-3 text-center" value="2">
            <qrcode-vue
              class="qr-width-50"
              :value="qrValue"
              render-as="svg"
              background="transparent"
            />
          </v-window-item>
          <v-window-item class="p-3 text-center" value="1">
            <Barcode :value="qrValue" />
          </v-window-item>
        </v-window>
        <div class="text-center f-bold">{{ qrValue }}</div>
        <div class="timer-countdown mt-4">
          <div>
            {{ countTime }}
          </div>
        </div>
        <c-btn block variant="confirm-primary" @click="hide">
          {{ $t("close_window") }}
        </c-btn>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ImageProfile from "@/components/profile/ImageProfile";
import picture from "@/assets/images/default-image.png";
import Barcode from "@/components/other/Barcode.vue";
var x;
export default {
  components: {
    ImageProfile,
    Barcode
  },
  props: {
    profile: {
      required: true,
      type: Object
    }
  },

  mounted() {},
  data() {
    return {
      showModal: false,

      countTime: "00:00",

      tabIndex: this.$config.line_setting_primary_code || 2,
      payload: {
        refDocId: 21,
        docType: 1
      },
      qrValue: ""
    };
  },
  watch: {
    showModal(value) {
      if (!value) {
        clearInterval(x);
      }
    }
  },
  computed: {},
  methods: {
    async show(id, type) {
      this.payload = {
        refDocId: id,
        docType: type
      };
      this.emitter.emit("showLoading");
      await this.getVerificationCode();
      this.emitter.emit("hideLoading");
      await this.$nextTick();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
      clearInterval(x);
    },

    countTimer() {
      function padZero(value) {
        value = String(value);
        return value.length == 1 ? "0" + value : value;
      }
      var countDownDate = this.$moment().add(10, "minute").valueOf();
      x = setInterval(() => {
        var now = this.$moment().valueOf();
        var distance = countDownDate - now;
        // var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        // var hours = padZero(
        //   Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        // );
        var minutes = padZero(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        );
        var seconds = padZero(Math.floor((distance % (1000 * 60)) / 1000));

        if (distance < 0) {
          clearInterval(x);
          return this.getVerificationCode();
        }
        this.$nextTick(() => {
          this.countTime = minutes + " : " + seconds;
        });
      }, 900);
    },
    async getVerificationCode() {
      const res = await this.$axios.post(
        "/api/v1/reward/GenVerifyQRCode",
        this.payload
      );
      this.qrValue = res.detail;
      this.countTimer();
    },
    dateFormat(value, format) {
      if (!value) return "-";
      if (!format) format = "DD-MM-YYYY";
      return this.$moment(value).format(format);
    },
    fillProfile() {
      this.showModal = false;
      this.$router.push("/edit-profile-required");
    },
    gotoProfile() {
      this.showModal = false;
      this.$router.push("/manage/profile");
    }
  }
};
</script>

<style lang="scss" scoped>
// @import "scss";
.profile-img-2 {
  width: 150px;
  height: 150px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid black;
  border-radius: 50%;
  margin: 1rem auto;
}
.qr-width-50 {
  width: 50% !important;
  height: 50% !important;
  padding: 0.5rem 0;
}
.profile-img.default {
  background-color: var(--primary-color);
  color: var(--font-primary-color);
  left: 6px !important;
  top: 6px !important;
}
.profile-img-2.default {
  background-color: var(--primary-color);
  color: var(--font-primary-color);
  left: 6px !important;
  top: 6px !important;
}
</style>
